import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const ProvidersMapContainer = styled(Box)`
  width: 100%;
  /* z-index: 9; */
`
export const Badge = styled.small`
  color: #f79009;
  font-weight: 500;
  border: 1px solid #f79009;
  background-color: #fde9ce;
  padding: 0.2rem 0.5rem;
  border-radius: 50px;
`

export const Switch = styled(Box)`
  display: flex;
  align-items: center;
  position: absolute;
  bottom: ${(props) => props.theme.spacing['4']};
  right: ${(props) => props.theme.spacing['4']};
  padding: 0.5rem 0;
  padding-right: 0.5rem;
  background-color: ${(props) => props.theme.colors.custom.white + 80};
  border-radius: ${(props) => props.theme.border_radius.input};
`
